<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { generateCodeChallenge } from "@/utils";
import authData from "@/data/authData.json";
import moment from "moment";
import swal from "sweetalert";

export default {
  name: "login",
  methods: {
    onLoginClick() {
      //redirect to generate authorization code
      let code_challenge = generateCodeChallenge();
      localStorage.setItem("code_challenge", code_challenge);
      // localStorage.getItem("code_challenge");
      // invoke http://127.0.0.1:8000/o/authorize/?response_type=code&code_challenge=6P9KYPF7CNDPWPDJPYA4IVJPE5LJRH3WC2E2OV6PO8ILVKL2U60FNPTGCQ&client_id=6kff1AW1uMdOfOHuJqeevdhph9saUH89ue2Ub1Bm&redirect_uri=http://127.0.0.1:8000/noexist/callback
      let getAuthorizationCodeUrl = new URL(`${process.env.VUE_APP_AUTHORIZATION_URL}` + "/o/authorize/?response_type=code");
      var search_params = getAuthorizationCodeUrl.searchParams;
      search_params.set('code_challenge', code_challenge);
      search_params.set('client_id', `${process.env.VUE_APP_CLIENT_ID}`);
      search_params.set('redirect_uri', `${process.env.VUE_APP_REDIRECT_URL}`);
      getAuthorizationCodeUrl.search = search_params.toString();
      var new_url = getAuthorizationCodeUrl.toString();
      window.location.replace(new_url);
    },
  },
  mounted() {
    //window.location.replace(`${process.env.VUE_APP_ABEN_WEB_BASE}/signin`);
    //   let now = new Date();
    //   let tokenData =this.$store.getters["getTokenData"];
    //   let expires_at = new Date(tokenData.expires_at);

    //   if (now < expires_at){
    //     let new_url = new URL(`${process.env.VUE_APP_DOMAINURL}`+"/dashboard");
    //     window.location.replace(new_url);
    //   }

    //   let externalScript = document.createElement('script')
    //   externalScript.setAttribute('src', 'https://prod-aben-assets.s3.amazonaws.com/assets/js/page.min.js')
    //   document.head.appendChild(externalScript)
    //   let externalScript2 = document.createElement('script')
    //   externalScript2.setAttribute('src', 'https://prod-aben-assets.s3.amazonaws.com/assets/js/gsap.min.js')
    //   document.head.appendChild(externalScript2)
    //   let externalScript3 = document.createElement('script')
    //   externalScript3.setAttribute('src', 'https://prod-aben-assets.s3.amazonaws.com/assets/js/ScrollTrigger.min.js')
    //   document.head.appendChild(externalScript3)
    //   let externalScript4 = document.createElement('script')
    //   externalScript4.setAttribute('src', 'https://prod-aben-assets.s3.amazonaws.com/assets/js/index.js')
    //   document.head.appendChild(externalScript4)

  },
};
</script>
<style>
@import 'https://prod-aben-assets.s3.amazonaws.com/assets/css/page.min.css';
@import 'https://prod-aben-assets.s3.amazonaws.com/assets/css/style.css';
@import 'https://prod-aben-assets.s3.amazonaws.com/assets/css/index.css';
</style>


<template>
  <v-app class="bg-transparent">
    <v-main>
      <!-- GSAP intro animation -->
      <!-- <div class="intro-cover"></div> -->

      <!-- Navbar -->
      <!-- <nav class="navbar navbar-expand-lg navbar-light navbar-stick-dark" data-navbar="sticky">
        <div class="container">

          <div class="navbar-left">
            <button class="navbar-toggler" type="button">&#9776;</button>
            <a class="navbar-brand" href="/">
              <img class="logo-dark" src="https://prod-aben-assets.s3.amazonaws.com/assets/img/logo-dark.svg"
                alt="logo">
              <img class="logo-light" src="https://prod-aben-assets.s3.amazonaws.com/assets/img/logo-light.svg"
                alt="logo">
            </a>
          </div>

          <div class="navbar-mobile">
            <span class="navbar-divider d-mobile-none"></span>

            <nav class="nav nav-navbar">
              <a class="nav-link" href="https://app.joinaben.com/features/">Features</a>
            </nav>
          </div>
          <a class="btn login" @click="onLoginClick();">Login</a>
          <a class="btn" href="https://app.joinaben.com/accounts/register/">Apply for Aben</a>

        </div>
      </nav> -->
      <!-- /.navbar -->

      <!-- Main Content -->
      <!-- <main class="main-content"> -->

      <!-- Landing section -->
      <!-- <section id="home">
          <div class="content-horizontal">
            <div class="text-content">
              <div class="medium">How&nbsp;effective&nbsp;is your marketing?</div>
              <div class="large"><span>Aben</span>&nbsp;makes it&nbsp;better.</div>
              <div class="small">
                Aben enables you to append contact information from existing credit
                card customers, run email marketing, and prove ROI by measuring
                revenue directly attributable to your email marketing.
              </div>
              <a href="https://app.joinaben.com//features/" class="btn">Find out how</a>
              <img src="https://prod-aben-assets.s3.amazonaws.com/assets/img/fallingmail.svg" alt="Falling letters"
                class="fallingmail">
            </div>
            <div class="img-content">
              <img class="applicationgraphic" src="https://prod-aben-assets.s3.amazonaws.com/assets/img/application.svg"
                alt="Application preview">
              <img class="applicationgraphic-mobile"
                src="https://prod-aben-assets.s3.amazonaws.com/assets/img/applicationmobile.svg"
                alt="Application preview">
            </div>
          </div>
        </section> -->

      <!-- Get email from credit card section -->
      <!-- <section class="section-darker" id="creditcard">
          <div class="content-vertical">
            <div class="text-content">
              <div class="medium">
                Find&nbsp;the&nbsp;email behind&nbsp;every&nbsp;credit&nbsp;card
              </div>
            </div>
            <div class="img-content">
              <img class="creditcardgraphic" src="https://prod-aben-assets.s3.amazonaws.com/assets/img/creditcard.svg"
                alt="Credit card to email graphic">
              <img class="creditcardgraphic-mobile"
                src="https://prod-aben-assets.s3.amazonaws.com/assets/img/creditcardmobile.svg"
                alt="Credit card to email graphic">
            </div>
          </div>
        </section> -->

      <!-- Track revenue section -->
      <!-- <section id="revenue" class="section">
          <div class="container">
            <div class="row">
              <div class="col-md-6 align-self-center text-center text-md-left">
                <div class="medium">Calculate revenue directly attributable to your email campaign</div><br>
                <div class="small">Our analytics make it easy to prove ROI by showing
                  how your email campaign affected your revenue.</div>
                <br>
              </div>
              <div class="col-md-5 mx-auto text-center mt-8 mt-md-0">
                <img class="revenuegraphic" src="https://prod-aben-assets.s3.amazonaws.com/assets/img/revenue.svg"
                  alt="Revenue chart">
              </div>
            </div>
          </div>
        </section> -->

      <!-- Bottom CTA section -->
      <!-- <section class="section py-7 section-darker">
          <div class="container">
            <div class="row gap-y align-items-center">
              <div class="col-md-6 text-center text-md-left">
                <div class="medium">Start using Aben</div>
                <small class="text-muted">Already using Aben? <a @click="onLoginClick();">Login</a></small>
              </div>
              <div class="col-md-auto ml-auto text-center text-md-right">
                <form class="form-inline justify-content-center">
                  <a class="btn" href="/accounts/register/">Apply for Aben</a>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main> -->

      <!-- Footer -->
      <!-- <footer class="footer">
        <div class="container">
          <div class="row gap-y align-items-center">

            <div class="col-1">
              <a href="/"><img class="logo-dark"
                  src="https://prod-aben-assets.s3.amazonaws.com/assets/img/logo-dark.svg" alt="logo"></a>
            </div>

            <div class="col-11">
              <div class="nav nav-uppercase nav-trim justify-content-lg-center">
                <a class="nav-link" href="https://prod-aben-assets.s3.amazonaws.com/legal/Aben_TOS.pdf">Terms of
                  Service</a>
                <a class="nav-link"
                  href="https://prod-aben-assets.s3.amazonaws.com/legal/Aben_Acceptable_Use.pdf">Acceptable Use
                  Policy</a>
                <a class="nav-link"
                  href="https://prod-aben-assets.s3.amazonaws.com/legal/Aben_Privacy_Policy.pdf">Privacy Policy</a>
                <a class="nav-link" href="https://prod-aben-assets.s3.amazonaws.com/legal/Aben_Data_Protection.pdf">Data
                  Protection Addendum</a>
              </div>
            </div>

          </div>
        </div>
      </footer> -->

    </v-main>
  </v-app>
</template>

